/**
 * Client-side collection filters (nicotine, model, flavor, color, vendor).
 * Lives outside Shopify's facet form so price/availability AJAX does not
 * submit these values. State is kept in the URL as lm_* params.
 */
(function () {
  var KEYS = ['nicotine', 'modelo', 'sabor', 'color', 'vendor'];
  var PARAM = {
    nicotine: 'lm_nicotine',
    modelo: 'lm_modelo',
    sabor: 'lm_sabor',
    color: 'lm_color',
    vendor: 'lm_vendor'
  };

  function grid() {
    return document.querySelector('#product-grid[data-lm-stock-sort]');
  }

  function items() {
    var root = grid();
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll('.lm-collection-item'));
  }

  function selected() {
    var out = {};
    KEYS.forEach(function (key) {
      out[key] = [];
    });
    document.querySelectorAll('.lm-product-filter:checked').forEach(function (input) {
      var key = input.getAttribute('data-lm-filter');
      if (!out[key] || out[key].indexOf(input.value) !== -1) return;
      out[key].push(input.value);
    });
    return out;
  }

  function valueList(el, key) {
    return String(el.getAttribute('data-lm-' + key) || '')
      .split('|')
      .map(function (part) { return part.trim(); })
      .filter(Boolean);
  }

  function matchesKey(el, key, values) {
    if (!values.length) return true;
    var productValues = valueList(el, key).map(function (part) { return part.toLowerCase(); });
    if (!productValues.length) return false;
    return values.some(function (value) {
      return productValues.indexOf(String(value).toLowerCase()) !== -1;
    });
  }

  function matches(el, state, skipKey) {
    return KEYS.every(function (key) {
      if (key === skipKey) return true;
      return matchesKey(el, key, state[key] || []);
    });
  }

  function syncCheckboxes(source) {
    var key = source.getAttribute('data-lm-filter');
    var value = source.value;
    document.querySelectorAll('.lm-product-filter[data-lm-filter="' + key + '"]').forEach(function (input) {
      if (input.value === value) input.checked = source.checked;
    });
  }

  function writeUrl(state) {
    try {
      var url = new URL(window.location.href);
      KEYS.forEach(function (key) {
        url.searchParams.delete(PARAM[key]);
        (state[key] || []).forEach(function (value) {
          url.searchParams.append(PARAM[key], value);
        });
      });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      }
    } catch (err) {}
  }

  function readUrl() {
    var state = {};
    try {
      var url = new URL(window.location.href);
      KEYS.forEach(function (key) {
        state[key] = url.searchParams.getAll(PARAM[key]);
      });
    } catch (err) {
      KEYS.forEach(function (key) { state[key] = []; });
    }
    return state;
  }

  function applyUrlToInputs(state) {
    document.querySelectorAll('.lm-product-filter').forEach(function (input) {
      var key = input.getAttribute('data-lm-filter');
      input.checked = (state[key] || []).indexOf(input.value) !== -1;
    });
  }

  function updateCounts(state) {
    document.querySelectorAll('.lm-product-filter').forEach(function (input) {
      var key = input.getAttribute('data-lm-filter');
      var count = items().filter(function (el) {
        return matches(el, state, key) && matchesKey(el, key, [input.value]);
      }).length;
      var label = input.nextElementSibling;
      var countEl = label && label.querySelector('.count');
      if (countEl) countEl.textContent = '(' + count + ')';
      var row = input.closest('li');
      if (row) row.hidden = count === 0 && !input.checked;
    });
  }

  function updateProductCount(visible) {
    document.querySelectorAll('.facets__label').forEach(function (el) {
      if (!el.closest('.thb-filter-count') && !el.closest('.facets--bar-right')) return;
      var text = el.textContent || '';
      el.textContent = text.replace(/\d[\d.]*/, String(visible));
    });
  }

  var REMOVE_ICON = '<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L1 7M7 7L1 1" stroke="var(--color-body)" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var skipPreserveParams = false;

  function chipLabel(input) {
    var label = input.nextElementSibling;
    var name = label && label.querySelector('.filter-name');
    return name ? name.textContent.trim() : input.value;
  }

  function emptyState() {
    var state = {};
    KEYS.forEach(function (key) { state[key] = []; });
    return state;
  }

  function updateActiveFacets() {
    var bar = document.querySelector('.active-facets');
    if (!bar) return;
    bar.querySelectorAll('.lm-active-facet').forEach(function (el) { el.remove(); });
    var clear = bar.querySelector('.active-facets__button-remove');
    var seen = {};
    document.querySelectorAll('.lm-product-filter:checked').forEach(function (input) {
      var key = input.getAttribute('data-lm-filter');
      var token = key + '\n' + input.value;
      if (seen[token]) return;
      seen[token] = true;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'active-facets__button lm-active-facet';
      button.setAttribute('data-lm-filter', key);
      button.setAttribute('data-lm-value', input.value);
      button.innerHTML = chipLabel(input) + '<span>' + REMOVE_ICON + '</span>';
      if (clear) bar.insertBefore(button, clear);
      else bar.appendChild(button);
    });
  }

  function mergeLmParams(url) {
    if (!url || skipPreserveParams) {
      skipPreserveParams = false;
      return url;
    }
    try {
      var next = new URL(url, window.location.origin);
      var current = new URL(window.location.href);
      KEYS.forEach(function (key) {
        if (next.searchParams.has(PARAM[key])) return;
        current.searchParams.getAll(PARAM[key]).forEach(function (value) {
          next.searchParams.append(PARAM[key], value);
        });
      });
      return next.pathname + next.search + next.hash;
    } catch (err) {
      return url;
    }
  }

  function patchHistory() {
    if (history.lmParamsPatched) return;
    history.lmParamsPatched = true;
    var push = history.pushState;
    history.pushState = function (state, title, url) {
      if (typeof url === 'string') url = mergeLmParams(url);
      return push.call(this, state, title, url);
    };
  }

  function clearCustomFilters() {
    document.querySelectorAll('.lm-product-filter:checked').forEach(function (input) {
      input.checked = false;
    });
    writeUrl(emptyState());
  }

  function apply(options) {
    var state = selected();
    var list = items();
    var visible = 0;
    list.forEach(function (el) {
      var ok = matches(el, state);
      el.classList.toggle('lm-filter-out', !ok);
      if (ok) visible += 1;
    });

    var empty = document.querySelector('.lm-filter-empty');
    if (empty) empty.hidden = visible > 0;

    updateCounts(state);
    updateProductCount(visible);
    updateActiveFacets();
    hideEmptyFilterGroups();
    if (!options || options.updateUrl !== false) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('lm_page');
        if (window.history && window.history.replaceState) {
          window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        }
      } catch (err) {}
      writeUrl(state);
    }
    if (typeof window.lmInitCollectionGrid === 'function') {
      window.lmInitCollectionGrid();
    }
    window.DtcEsTracking?.filterResult(visible, options && options.userAction);
  }

  function onInput(event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('lm-product-filter')) return;
    event.stopPropagation();
    syncCheckboxes(input);
    apply({ userAction: 'apply' });
  }

  function onActiveClick(event) {
    var chip = event.target.closest && event.target.closest('.lm-active-facet');
    if (chip) {
      event.preventDefault();
      event.stopPropagation();
      var key = chip.getAttribute('data-lm-filter');
      var value = chip.getAttribute('data-lm-value');
      document.querySelectorAll('.lm-product-filter').forEach(function (input) {
        if (input.getAttribute('data-lm-filter') === key && input.value === value) {
          input.checked = false;
        }
      });
      apply({ userAction: 'remove_one' });
      return;
    }
    if (event.target.closest && event.target.closest('.active-facets__button-remove')) {
      skipPreserveParams = true;
      clearCustomFilters();
      apply({ updateUrl: false, userAction: 'clear_all' });
    }
  }

  function ignoreShopifyFacetSubmit(event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('lm-product-filter')) return;
    event.stopPropagation();
  }

  function releaseFilterScroller() {
    document.querySelectorAll('.facets-desktop-container sticky-scroller').forEach(function (el) {
      if (el.onWindowScrollBound) {
        window.removeEventListener('scroll', el.onWindowScrollBound);
      }
      if (el.observer) el.observer.disconnect();
      var inner = el.querySelector('.sticky-scroller--element');
      if (inner) inner.style.overflowY = '';
    });
  }

  function titleOf(row) {
    var summary = row.querySelector('.thb-filter-title');
    if (!summary) return '';
    var clone = summary.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('span, svg'), function (el) {
      el.remove();
    });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function sortFilterValues(row) {
    if (row.querySelector('.price_range, .thb-filter-availability')) return;
    var list = row.querySelector('ul');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li'));
    if (items.length < 2) return;
    var lang = (document.documentElement.lang || 'es').split('-')[0];
    items.sort(function (a, b) {
      var at = ((a.querySelector('.filter-name') || a).textContent || '').trim();
      var bt = ((b.querySelector('.filter-name') || b).textContent || '').trim();
      return at.localeCompare(bt, lang, { sensitivity: 'base', numeric: true });
    });
    items.forEach(function (li) {
      list.appendChild(li);
    });
  }

  function sortFilterGroups() {
    var lang = (document.documentElement.lang || 'es').split('-')[0];
    document.querySelectorAll('.facets__wrapper, #FacetFiltersFormMobile').forEach(function (container) {
      var rows = Array.prototype.slice.call(
        container.querySelectorAll(':scope > collapsible-row, :scope > .lm-product-filters > collapsible-row')
      );
      if (!rows.length) return;
      rows.sort(function (a, b) {
        return titleOf(a).localeCompare(titleOf(b), lang, { sensitivity: 'base' });
      });
      rows.forEach(function (row, index) {
        sortFilterValues(row);
        row.style.order = String(index + 1);
      });
      var trailer = container.querySelector('.thb-filter-sort-count');
      if (trailer) trailer.style.order = String(rows.length + 1);
    });
  }

  function clearFilterAnimation(details) {
    if (!details) return;
    if (typeof details.getAnimations === 'function') {
      details.getAnimations().forEach(function (animation) {
        animation.cancel();
      });
    }
    details.style.height = '';
    details.style.overflow = '';
    var row = details.closest('collapsible-row');
    if (row) {
      row.isClosing = false;
      row.isExpanding = false;
      row.animation = null;
    }
  }

  /**
   * Vision's collapsible-row preventDefault()s the native <details> toggle and
   * animates height. sortFilterGroups used to re-append those nodes, which
   * stacked click handlers so collapse immediately re-opened. Take the click
   * in capture, skip that animation, and toggle [open] ourselves.
   */
  function onFilterSummaryClick(event) {
    var summary = event.target.closest && event.target.closest('summary.thb-filter-title');
    if (!summary) return;
    var details = summary.closest('details.thb-filter');
    if (!details) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    clearFilterAnimation(details);
    if (details.hasAttribute('open')) {
      details.removeAttribute('open');
    } else {
      details.setAttribute('open', '');
    }
  }

  function hideEmptyFilterGroups() {
    document.querySelectorAll('collapsible-row').forEach(function (row) {
      if (!row.querySelector('.lm-product-filter')) return;
      var visible = row.querySelectorAll('li:not([hidden])').length;
      row.hidden = visible === 0;
    });
  }

  function initFromUrl() {
    releaseFilterScroller();
    if (!document.querySelector('[data-lm-product-filters]')) return;
    sortFilterGroups();
    var state = readUrl();
    applyUrlToInputs(state);
    apply({ updateUrl: false });
  }

  patchHistory();
  document.addEventListener('input', ignoreShopifyFacetSubmit, true);
  document.addEventListener('change', onInput);
  document.addEventListener('click', onFilterSummaryClick, true);
  document.addEventListener('click', onActiveClick, true);
  document.addEventListener('facets:updated', function () {
    setTimeout(initFromUrl, 0);
  });
  initFromUrl();
})();
